import { Check, ArrowRight } from "lucide-react";
import { FadeUp, Counter } from "./Motion";
import { setSelectedPackage } from "../../lib/api";
import { track } from "../../lib/analytics";

export function PricingCards({ packages, onSelect, selected }) {
  const list = Array.isArray(packages) ? packages : [];
  const choose = (pkg) => {
    setSelectedPackage(pkg.id);
    track("SelectPackage", { package: pkg.id, value: pkg.price, currency: "USD" });
    onSelect?.(pkg);
  };
  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 lg:items-stretch">
      {list.map((pkg, i) => {
        const featured = Boolean(pkg.badge);
        const isSel = selected === pkg.id;
        return (
          <FadeUp key={pkg.id} delay={i * 0.1} className="h-full">
            <article data-testid={`pricing-card-${pkg.id}`}
              className={`relative flex h-full flex-col rounded-[28px] p-7 sm:p-8 transition-[transform,border-color] duration-500 hover:-translate-y-1 ${featured ? "border border-electric/60 bg-gradient-to-b from-electric/[0.16] via-panel to-panel shadow-[0_30px_90px_-40px_rgba(0,136,255,0.9)]" : "border border-white/[0.08] bg-panel/70"} ${isSel ? "ring-2 ring-cyan-300" : ""}`}>
              {featured && <span className="absolute -top-3 left-7 rounded-full bg-electric px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-white" data-testid={`pricing-badge-${pkg.id}`}>{pkg.badge}</span>}
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Package {String(i + 1).padStart(2, "0")}</p>
              <h3 className="mt-2 text-2xl font-semibold tracking-tight text-white">{pkg.name}</h3>
              <p className="mt-6 flex items-baseline gap-1">
                <span className="text-5xl font-semibold tracking-[-0.04em] text-white"><Counter value={pkg.price} prefix="$" /></span>
                <span className="text-sm text-slate-400">/month</span>
              </p>
              <p className="mt-2 text-sm font-medium text-cyan-300">{pkg.creatives} Creatives Per Month</p>
              <p className="mt-5 text-sm leading-relaxed text-slate-300">{pkg.description}</p>
              <ul className="mt-6 flex-1 space-y-3 border-t border-white/[0.07] pt-6">
                {(Array.isArray(pkg.features) ? pkg.features : []).map((f) => (
                  <li key={f} className="flex gap-3 text-sm text-slate-300"><Check className="mt-0.5 h-4 w-4 shrink-0 text-cyan-300" />{f}</li>
                ))}
              </ul>
              <button onClick={() => choose(pkg)} data-testid={`pricing-select-${pkg.id}-btn`} className={`${featured ? "btn-primary" : "btn-ghost"} group mt-8 w-full`}>
                {isSel ? "Selected — continue below" : pkg.cta} <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </article>
          </FadeUp>
        );
      })}
    </div>
  );
}

export function PricingDisclosure({ text }) {
  return (
    <p className="mt-8 rounded-2xl border border-white/[0.07] bg-white/[0.02] px-5 py-4 text-sm text-slate-300" data-testid="pricing-disclosure">
      <strong className="font-semibold text-white">{text || "Advertising spend is separate from monthly agency fees."}</strong>{" "}
      No payment is taken on this website — choosing a package simply tells us what you're interested in before we talk.
    </p>
  );
}
